import type { SelectOption } from '@/shared/ui/selectTypes';

interface RawOption {
  id?: string | number;
  value?: string | number;
  name?: string;
  title?: string;
  label?: string;
}

/** Accepts both `{ value, label }` and `{ id, name | title }` API shapes. */
export const normalizeOptions = (items: RawOption[] = []): SelectOption[] =>
  items.map((item) => {
    const value = item.value ?? item.id ?? '';
    return { value: String(value), label: String(item.label ?? item.name ?? item.title ?? value) };
  });
